<template>
    <div>
        <headerPage></headerPage>

        <div class="w1200 sss_zhuanlan">
            <div class="left">
                <div class="header">
                    <div class="user">

                        <img class="avatar" v-if="userInfo.avatar" :src="baseUrl + userInfo.avatar" alt="头像" />
                        <img class="avatar" v-else src="@/assets/default_avatar.png" alt="头像" />
                        <div style="display:flex">
                            <div>
                                <!-- <div class="name">{{ userInfo.nickname }}（缩水师）</div> -->
                                <div style="display:flex;align-items: center;">
                                    <div class="name">{{ userInfo.nickname }}</div>
                                    <!-- 这里后台暂时未返回  先固定缩水师 -->
                                    <div class="roleTab">
                                        <div class="item activeitem">
                                            缩水师
                                        </div>
                                        <div class="item">
                                            技巧师
                                        </div>
                                        <div class="item">
                                            软件师
                                        </div>

                                    </div>
                                </div>
                                <div class="content" style=" margin-top: 12px; line-height: 25px; ">
                                    <div>
                                        <div>双色球：{{userInfo.doubleColorBall || 0}}</div>
                                        <div>大乐透：{{userInfo.lottery || 0}}</div>
                                        <!--                                        <el-button :type="toggleActive == 0? 'primary' : 'info'" style="width:160px;margin-top: 5px;" @click="toggleActive = 0">预测列表</el-button>-->
                                    </div>
                                    <div>
                                        <div>福彩3D：{{userInfo.fucai3d || 0}}</div>
                                        <div>体彩排三：{{userInfo.pailieSan || 0}}</div>
                                        <!--                                        <el-button style="width:160px;margin-top: 5px;" :type="toggleActive == 1? 'primary' : 'info'" @click="toggleActive = 1">近期成绩</el-button>-->
                                    </div>
                                    <div>
                                        <div>缩币缩水单：{{userInfo.payCount || 0}}</div>
                                        <div>免费缩水单：{{userInfo.freeCount || 0}}</div>
                                        <!--                                        <el-button style="width:160px;margin-top: 5px;" :type="toggleActive == 2? 'primary' : 'info'" @click="toggleActive = 2">历史排序</el-button>-->
                                    </div>
                                    <el-tabs v-model="activeName" @tab-click="handleClick">
                                        <el-tab-pane label="预测列表" name="first"></el-tab-pane>
                                        <el-tab-pane label="近期成绩" name="second"></el-tab-pane>
                                        <el-tab-pane label="历史排序" name="third"></el-tab-pane>
                                    </el-tabs>
                                </div>
                            </div>
                            <div class="btns">
                                <div @click="$router.push('/personalCenter/hangjiaguanli/apply_sss')">申请缩水师</div>
                                <div>申请EXCEL表修复</div>
                                <div>申请EXCEL技巧师</div>
                                <div>申请定制EXCEL表</div>
                                <div>申请投注站帮扶</div>
                                <div>申请定制缩水软件</div>
                            </div>
                        </div>

                    </div>
                    <div class="msg">
                        座右铭或者简介：
                        <div> {{userInfo.motto}} </div>
                    </div>
                </div>

                <div class="table1" v-show="[0,1].includes(toggleActive)">
                    <div class="tit">
                        <div>
                            <span>最新预测</span>
                            <span v-for="(item,index) in lotteryArryOne" :key="index" :class="{active: index == lotteryActiveOne}" @click="lotteryActiveOne = index">
                                {{item.title}}
                            </span>
                        </div>
                        <span>更多预测</span>
                    </div>
                    <div class="grid">
                        <div>
                            <span>序号</span>
                            <span>最新缩水预测</span>
                            <span>类型</span>
                            <span>发布时间</span>
                            <span>操作</span>
                        </div>
                        <div v-for="(item,index) in latest_forecast_list" :key="index">
                            <span>{{index+1}}</span>
                            <span style="white-space: nowrap;">{{ item.title }}</span>
                            <span v-if="item.coin" style="color:red">付费</span>
                            <span v-else>免费</span>
                            <span>{{item.createTime.substr(0,10)}}</span>
                            <el-button @click="handleDownload(item,item.preIndexType,item.preIndexTypeName,item.preIndexTypeAlies)" type="text" size="small">下载</el-button>
                        </div>
                    </div>
                </div>
                <div class="table2" v-show="[0,1].includes(toggleActive)">
                    <div class="tit">
                        <div>
                            <b style="color:#000;margin-right:20px">{{userInfo.nickname}}</b>
                            <span>近期成绩</span>
                            <span v-for="(item,index) in lotteryArry" :key="index" :class="{active: index == lotteryActive}" @click="lotteryActive = index">
                                {{item.title}}
                            </span>
                        </div>
                        <span @click="recent_achievements(20)">更多预测</span>
                    </div>

                    <div class="grid" v-if="lotteryArry?.length" v-loading="recent_results_loading">

                        <div :style="['pl3','fc3d'].includes(lotteryArry[lotteryActive].type)?'grid-template-columns: 1fr repeat(7, 1fr);':''">
                            <span>序号</span>
                            <span>期号/开奖号</span>
                            <span v-for="(item,index) in ys[lotteryArry[lotteryActive].type]" :key="index">
                                {{item.label}}
                            </span>
                        </div>
                        <div v-for="(item,index) in recent_results_list" :key="index" :style="['pl3','fc3d'].includes(lotteryArry[lotteryActive].type)?'grid-template-columns: 1fr repeat(7, 1fr);':''">
                            <span>{{index+1}}</span>
                            <span>
                                {{item.number}}期<br />
                                <span style="flex-direction: row;border:0" v-html="openBbr(item.openNbr)"></span>
                            </span>
                            <span v-for="(ite,idx) in ys[lotteryArr[lotteryActive].type]" :key="idx" class="sheetItem">
                                <b v-if="jsAttr(item.openNbr,item.preChampionVOList,ite.value,'isDC' ) == '--'" style="color:#000">--</b>
                                <b v-else-if="jsAttr(item.openNbr,item.preChampionVOList,ite.value,'isDC') == 1" style="color:#2899DF">√</b>
                                <b v-else style="color:#f00">×</b>
                                <span class="show" @click="goToPay(item, ite)" @mouseover="handleMouseOver(item, ite,'blue')" @mouseleave="handleMouseLeave" v-html="jsAttr(item.openNbr, item.preChampionVOList, ite.value, 'show')"></span>
                                <div v-if="isHovered && ite.value===5" class="hidden-element">{{blueNumber}}</div>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="lottery" v-if="toggleActive == 2 && lotteryArr?.length">
                    <div v-for="(item,index) in lotteryArr" :key="index" :class="{active: index == lotteryActive}" @click="lotteryToggle(index)">{{item.label}}</div>
                </div>
                <div class="preIndexType" v-if="toggleActive == 2">
                    <div v-for="(item,index) in preIdexType" :key="index" :class="{ active:preIdexTypeActive == index }" @click="preIndexTypeToggle(index)">
                        {{item.dictLabel}}
                    </div>
                </div>
                <div class="history_sorting_table" v-if="toggleActive == 2">
                    <el-table :data="history_sorting" border :cell-style="{padding: '0'}" style="width: 100%;min-height: 370px;" v-loading="history_sorting_loading">
                        <el-table-column prop="number" label="期号" width="100" />
                        <el-table-column prop="lotteryDraw" label="开奖号" width="180">
                            <template slot-scope="scope">
                                <div style="margin-left: 10px;" v-if="scope.row.lotteryDraw">
                                    <span style="color:red">{{scope.row.lotteryDraw.substring(0,17)}}</span> +
                                    <span style="color:blue">{{scope.row.lotteryDraw.substring(17)}}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="lotteryDraw" label="已选号码">
                            <template slot-scope="scope">
                                <div class="spans" v-if="scope.row.hisAnalyzeDTOList.length">

                                    <!-- 双色球:(0,33),大乐透:(1,35),福彩3D:9,排列三:9 -->
                                    <template v-if="lotteryActive == 0 || lotteryActive == 1">
                                        <template v-for="(item,index) in scope.row.selected">
											<template v-if="!(['6N','lottery'].includes(item.num))">
												<span v-if="lotteryActive == 0 && item.num" :key="index" :class="{ correct:item.ischecked, blankLine: [22,11].includes(index) }"> {{item.num}} </span>
												<span v-if="lotteryActive == 1" :key="index" :class="{ correct:item.ischecked, blankLine: [7,14,21,28,35].includes(index) }"> {{item.num}} </span>
											</template>
                                        </template>
                                    </template>
                                    <!-- 福彩3D|排列三 -->
                                    <!-- <template v-if="lotteryActive == 2 || lotteryActive == 3">
                                        <template v-for="(item,index) in scope.row.selected.slice(0,10)">
                                            <span :key="index" style="flex:1" :class="{ correct:item.ischecked}"> {{item.num}} </span>
                                        </template>
                                    </template> -->

                                </div>
                            </template>
                        </el-table-column>
                    </el-table>

                    <!-- <el-pagination background
                                   layout="prev, pager, next"
                                   :current-page.sync="pagin.pageNum"
                                   :page-size="pagin.pageSize"
                                   :total="pagin.total"
                                   @current-change="e=>pagin.pageNum=e">
                    </el-pagination> -->

                </div>
            </div>
        </div>

        <fooderPage></fooderPage>

        <look-pre ref="lookPre" />
        <pay ref="pay" @pay_downFile_progress="pay_downFile_progress" />

    </div>
</template>

<script>
import headerPage from "@/views/common/header.vue";
import fooderPage from "@/views/common/fooder.vue";
import { getInfo } from "@/api/hangjiaguanli";
import { createOrder, queryDictionary } from "@/api/common"
import pay from "@/components/pay.vue";
import lookPre from "../components/lookPre.vue"
import tableMixin from '@/views/homePage/menu/suoshuidan_dating/table/mixin.js'



export default {
    watch: {
        lotteryActive (val) {
            this.recent_achievements()
        },
        lotteryActiveOne (val) {
            if (this.lotteryActiveOne >= 1) {
                this.latest_forecast(this.lotteryActiveOne - 1);
            } else {
                this.latest_forecast();
            }

        },
        toggleActive (val) {
            if ([0, 1].includes(val)) {
                this.init(this.$route.query.shrinkId);
            } else {
                this.getLottery()
            }
        },
        isHovered (newVal) {
            if (newVal && this.hoveredIte && this.hoveredIte.value === 5) {
                this.goToPay(this.currentItem, this.hoveredIte, this.er);
            }
        },
        hoveredIte: {
            handler (newVal) {
                if (this.isHovered && newVal && newVal.value === 5) {
                    this.goToPay(this.currentItem, newVal);
                }
            },
            deep: true
        }
    },
    mixins: [tableMixin],
    components: {
        headerPage,
        fooderPage,
        lookPre,
        pay,
    },
    computed: {
        openBbr () {
            return (openNumber) => {
                if (openNumber) {
                    let data = openNumber.split(' ');
                    return `
						<b style="color:red">
							${data.splice(0, 6).join(' ')}
						</b>
						+<b style="color:blue;margin-left:5px">
							${data.splice(-1)}
						</b>
					`
                }
            }
        },
        jsAttr () {
            return (openNbr, arr, val, type) => {
                // console.log(
                //    'arr', JSON.parse(JSON.stringify(arr)),
                //     JSON.parse(JSON.stringify(val)),
                //     JSON.parse(JSON.stringify(type)),
                // );

                // return
                if (arr.length) {

                    let arr_filter = arr.filter(item => item.preIndexType == val);
                    let { isWin, isUpdate, realBetNumber, preIndexType, expand } = arr_filter.length && arr_filter[0]
                    // return is_win == 1 ? '√' : '×'
                    if (type == 'isDC') {
                        return isUpdate == '0' ? '--' : isWin
                    }
                    if (type == 'show') {
                        // 围四：preIndexType = 6
                        // 杀6：preIndexType = 5
                        if (!preIndexType) {
                            return '暂无内容'
                        }


                        if (['6', '5'].includes(preIndexType)) {
                            // let openBbr_last = openNbr.split(' ').slice(-1),
                            //     expand_arr = expand.split(' ');
                            // // console.log('openNbr',openBbr_last);
                            // // console.log('expand',expand_arr);
                            // if (preIndexType == '5') {
                            //     let str = ''
                            //     expand_arr.forEach((item, index) => { str += item == openBbr_last[0] ? `<b style="color:#000">${item}</b> ` : `<b style="color:red">${item}</b> ` })
                            //     return str
                            // }

                            // if (preIndexType == '6') {
                            //     let str = ''
                            //     expand_arr.forEach((item, index) => { str += item == openBbr_last[0] ? `<b style="color:red">${item}</b> ` : `<b style="color:#000">${item}</b> ` })
                            //     return str
                            // }

                            // return expand
                            return '查阅'
                        } else {
                            return realBetNumber + '注'
                        }
                    }
                }
            }
        }
    },
    data () {
        return {
            isHovered: false,
            hoveredIte: null,
            er: '',
            blueNumber: '',
            activeName: 'first',

            handleLink: '',


            toggleActive: 0,


            dialog: {
                show: false,
            },

            baseUrl: process.env.VUE_APP_BASE_API + '/stage-api',
            userInfo: {},

            // 预测列表
            latest_forecast_list: [],

            recent_results_list: [],
            recent_results_loading: false,

            ys: {
                ssq: [
                    { label: '90-99.9万', value: 7 },
                    { label: '80-89.9万', value: 0 },
                    { label: '50-59.9万', value: 1 },
                    { label: '15-21.9万', value: 2 },
                    { label: '4-9.9万', value: 3 },
                    { label: '5005注以下', value: 4 },
                    { label: '杀6蓝', value: 5 },
                    { label: '围4蓝', value: 6 },
                ],
                dlt: [
                    { label: '27-29.9万', value: 7 },
                    { label: '20-26.9万', value: 0 },
                    { label: '15-17.9万', value: 1 },
                    { label: '3-5.9万', value: 2 },
                    { label: '1-1.9万', value: 3 },
                    { label: '4368注以下', value: 4 },
                    { label: '杀5后', value: 5 },
                    { label: '围3后', value: 6 },
                ],
                fc3d: [
                    { label: '800-899注', value: 5 },
                    { label: '700-799注', value: 0 },
                    { label: '400-599注', value: 1 },
                    { label: '200-399注', value: 2 },
                    { label: '50-199注', value: 3 },
                    { label: '1-49注', value: 4 },
                ],
                pl3: [
                    { label: '800-899注', value: 5 },
                    { label: '700-799注', value: 0 },
                    { label: '400-599注', value: 1 },
                    { label: '200-399注', value: 2 },
                    { label: '50-199注', value: 3 },
                    { label: '1-49注', value: 4 },
                ],
            },

            // 历史排序
            history_sorting: [],
            history_sorting_loading: false,

            // 彩种
            lotteryArry: [
                { preType: 0, title: '双色球', type: 'ssq' },
                { preType: 1, title: '大乐透', type: 'dlt' },
                { preType: 2, title: '福彩3D', type: 'fc3d' },
                { preType: 3, title: '排列三', type: 'pl3' },
            ],
            lotteryActive: 0,
            preIdexType: [],
            preIdexTypeActive: 0,


            lotteryArryOne: [
                { preType: 4, title: '全部', type: 'qb' },
                { preType: 0, title: '双色球', type: 'ssq' },
                { preType: 1, title: '大乐透', type: 'dlt' },
                { preType: 2, title: '福彩3D', type: 'fc3d' },
                { preType: 3, title: '排列三', type: 'pl3' },
            ],
            lotteryActiveOne: 0,
            preIdexTypeOne: [],
            preIdexTypeActiveOne: 0,


            pagin: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
        }
    },
    mounted () {
        console.log('xxx', this.$route);
        let shrinkId = this.$route.query.shrinkId;
        let number = this.$route.query.number;
        let userName = this.$route.query.userName;
        let preType = this.$route.query.preType;

      //  this.init()
    },
    methods: {
        handleMouseOver (item, ite, er) {
            this.currentItem = item;
            this.hoveredIte = ite;
            this.isHovered = true;
            this.er = er;

        },
        handleMouseLeave () {
            this.isHovered = false;
            this.hoveredIte = null;
            this.blueNumber = '';
        },
        handleClick (tab) {
            if (tab.name === 'third') {
                this.toggleActive = 2;
            }
            if (tab.name === 'first') {
                this.toggleActive = 0;
            }
            if (tab.name === 'second') {
                this.toggleActive = 1;
            }
        },
        init (shrinkId) {
            console.log('查看历史 - init', shrinkId);
            this.dialog.show = true;

            this.shrinkId = this.$route.query.shrinkId;
            // this.shrinkId = 43;
            // this.getList()
            this.getLottery()
        },

        lotteryToggle (index) {
            this.lotteryActive = index
            this.preIdexTypeActive = 0
            this.get_pre_index_type(this.lotteryArr[index].apiUrl)
        },
        preIndexTypeToggle (index) {
            this.preIdexTypeActive = index
            this.get_history_sorting()
        },

        getLottery () {
            queryDictionary('pre_type').then(res => {
                const lotteryTypeMap = {
                    '双色球': { type: 'ssq', apiUrl: 'pre_double_index_type' },
                    '大乐透': { type: 'dlt', apiUrl: 'pre_lottery_index_type' },
                    '福彩3D': { type: 'fc3d', apiUrl: 'pre_fucai3d_index_type' },
                    '排列三': { type: 'pl3', apiUrl: 'pre_pailiesan_index_type' },
                };

                let lotteryArr = res.data.map(item => {
                    return {
                        label: item.dictLabel,
                        value: item.dictValue,
                        type: lotteryTypeMap[item.dictLabel].type,
                        apiUrl: lotteryTypeMap[item.dictLabel].apiUrl,
                    }
                })

                this.lotteryArr = lotteryArr

                // 使用这些参数
                if ([0, 1].includes(this.toggleActive)) {
                    // this.init(shrinkId);
                    this.getList()
                } else {
                    this.get_pre_index_type(lotteryArr[0].apiUrl)
                }

            })
        },

        get_pre_index_type (preIndexType) {
            this.$http.get('/stage-api/pre/dict/type/' + preIndexType).then(res => {
                let preIdexType = res.data.map(item => {
                    return (!['杀6蓝', '围4蓝'].includes(item.dictLabel)) && {
                        dictLabel: item.dictLabel,
                        dictValue: item.dictValue,
                    }
                })
                this.preIdexType = preIdexType
                this.get_history_sorting()
            })
        },

        // 获取历史排序
        get_history_sorting () {

            this.history_sorting_loading = true
            this.history_sorting = []

            let paramsUrl = this.$utils.getParamByJson(this.pagin)
            this.$http.post('/stage-api/pre/detail/analyzes?' + paramsUrl,
                {
                    "preType": this.lotteryArr[this.lotteryActive].value || 0,
                    "preIndexType": this.preIdexType[this.preIdexTypeActive].dictValue || 0,
                    "number": "",
                    "isToll": "",
                    userName: this.$route.query.userName,
                    // userName: '金香玉',
                    "hisCycle": "10",
                }
            ).then(res => {
                this.history_sorting_loading = false

                let numEn = [
                    'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
                    'eleven', 'tweleve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'ninetee', 'twenty',
                    'twentyOne', 'twentyTwo', 'twentyThree', 'twentyFour', 'twentyFive', 'twentySix', 'twentySeven', 'twentyEight', 'twentyNine',
                    'thirty', 'thirtyOne', 'thirtyTwo', 'thirtyThree', 'thirtyFour', 'thirtyFive'];

                console.log('res', res);

                res.rows.forEach(item => {
                    if (item.recordResultDTO != null) {
                        if (item.lotteryDraw) {
                            let lotteryDraw = JSON.parse(JSON.stringify(item.lotteryDraw.split(' ')));
                            let newLotteryDraw = lotteryDraw.slice(0, -1); // 去掉最后一位
                            item.selected = []
                            numEn.forEach(en => {
                                item.selected.push({
                                    ischecked: newLotteryDraw.includes(item.recordResultDTO[en]),
                                    // ischecked: lotteryDraw.includes(item.recordResultDTO[en]),
                                    num: item.recordResultDTO[en]
                                })
                            })
                        }
                    }
                })

                this.history_sorting = res.rows;
                this.pagin.total = res.total;

                console.log('this.history_sorting', JSON.parse(JSON.stringify(this.history_sorting)));

                // console.log('sssssss',res.rows.map(item=>item.selected));
            })
        },

        // 去支付
        goToPay (item, ite, er) {
            console.log(
                '单条数据日志',
                JSON.parse(JSON.stringify(item)),
                JSON.parse(JSON.stringify(ite))
            );

            new Promise((resolve, reject) => {
                let { preType, number, createUser } = item;
                let params = { preType, preIndexType: ite.value, number, createUser, }
                this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params).then(res => resolve(res.data))
            }).then(async res => {
                console.log('resxxx', res);
                console.log('查询下载预测文件所需价格 - res', res);
                let { orderNo, price, productId, specsId } = res

                if (orderNo) {
                    if ([5, 6].includes(ite.value)) {
                        this.preView(price, orderNo, ite.label, er)
                    } else {
                        // 下载文件
                        this.downloadFile(orderNo, price, item, ite.value)
                    }
                } else {
                    if (price) {
                        let {avatar,nickname} = this.userInfo
                        let payDb = {
                            avatar: avatar ? (this.baseUrl + avatar) :'',
                            title: item.title,
                            nickName:nickname,
                            number: item.number,
                            shrinkId: item.createUser,
                            indexName: ite.label,
                            strJson: item.preChampionVOList.filter(findItem => findItem.preIndexType === ite.value)[0],
                            lotteryType: item.preType,
                            price, productId, specsId,
                        }
                        this.$refs.pay.init(payDb)
                    } else {
                        let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
                        if (!resCreateOrder) {
                            return;
                        }
                        console.log('resCreateOrder----------------', resCreateOrder);
                        setTimeout(_ => {
                            this.preView(price, resCreateOrder, ite.label)
                        }, 1000)
                    }
                }
            })

        },
        // 支付进度条
        pay_downFile_progress (params) {

            console.log('pay_downFile_progress', params);


            let that = this
            setTimeout(_ => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params,
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        // console.log(`下载进度: ${percentCompleted}%`);

                        console.log('that.$parent', that.$parent);
                        that.downFile_progress = percentCompleted >= 100 ? false : percentCompleted
                    },
                }).then(downRes => {

                    console.log('downRes', downRes);

                    if (downRes.code == 500) {
                        return this.$message.error(res.msg)
                    }

                    let preTypeLabel = this.paydb.lotteryType == 0 ? '双色球' :
                        this.paydb.lotteryType == 1 ? '大乐透' :
                            this.paydb.lotteryType == 2 ? '福彩3D' :
                                this.paydb.lotteryType == 3 ? '体彩排三' : ''
                    let fileName = `${preTypeLabel}-${this.paydb.number}期-${this.paydb.nickName}-${this.paydb.indexName}.zip`
                    this.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            }, 1000)
        },
        // 免费和收费查看彩种额外指标  (点击了查阅按钮)
        preView (price, orderNo, indexNam, ere) {
            this.$http.get('/stage-api/pre/detail/additional/indicators', {
                params: {
                    coin: price,
                    orderNo,
                    pageNum: 1,
                    pageSize: 10,
                }
            }).then(res => {
                console.log('免费和收费查看彩种额外指标 - res', res);

                if (res.code == 500) {
                    return this.$message.error(res.msg)
                }
                if (ere == 'blue') {
                    this.blueNumber = JSON.parse(JSON.stringify(res.data[0])).additionalIndicators;
                    console.log('blueNumber', this.blueNumber);
                } else {
                    this.$refs.lookPre.init(res, indexName)
                    this.$emit('look_downFile', res)
                }
            })
        },

        // 查阅
        chayue (item) {
            console.log('item', JSON.parse(JSON.stringify(item)));
            let params = {
                preType: item.preType,
                preIndexType: item.preIndexType,
                number: item.number,
                createUser: item.createUser,
            }
            this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params).then(async res => {
                console.log('res', res);
                let { orderNo, price, productId, specsId } = res
                if (orderNo) {
                    // 下载文件
                    this.downloadFile(orderNo, price, item, preIndexTypeLabel)
                } else {
                    if (price) {
                        let payDb = {
                            avatar: process.env.VUE_APP_BASE_API + 'stage-api' + item.avatar,
                            title: item.title,
                            nickName: item.nickName,
                            number: item.number,
                            shrinkId: item.shrinkId,
                            indexName: item.indexName,
                            strJson: JSON.parse(item[preIndexTypeLabel]),
                            lotteryType: item.preType,
                            price, productId, specsId,
                        }
                        this.$emit('view_download', payDb)
                    } else {
                        let resCreateOrder = await this.fun_createOrder(price, item, productId, specsId)
                        if (!resCreateOrder) {
                            return;
                        }
                        console.log('resCreateOrder----------------', resCreateOrder);
                        // 下载文件
                        this.downloadFile(resCreateOrder, price, item, preIndexTypeLabel)
                    }
                }
            })
        },

        getList () {
            this.$http.get('/stage-api/lottery/technician/identity?userId=' + this.shrinkId).then(res => {
                // console.log('identity', JSON.parse(JSON.stringify(res.data)));
                console.log('identity', res.data);
                this.userInfo = res.data;
                this.latest_forecast()
                this.recent_achievements()
            })
        },
        // 预测列表
        latest_forecast (type) {
            this.$http.get('/stage-api/pre/detail/getPreRecordList', {
                params: {
                    createUser: this.shrinkId,
                    preType: type,
                }
            }).then(res => {
                this.latest_forecast_list = res.data.splice(0, 10)
            })
        },

        // 近期成绩
        recent_achievements (dbLen = 7) {

            console.log('this.lotteryArr[this.lotteryActive]', this.lotteryArr[this.lotteryActive]);

            this.recent_results_list = []
            this.recent_results_loading = true
            this.$http.get('/stage-api/pre/detail/achievmentList', {
                params: {
                    preType: this.lotteryArr[this.lotteryActive].value,
                    createUser: this.shrinkId,
                }
            }).then(res => {
                this.recent_results_loading = false
                let db = res.rows.splice(0, dbLen)
                this.recent_results_list = db
            }).catch(err => {
                console.log('err', err);
                this.recent_results_loading = false
            })
        },

        // 下载文件
        downloadFile (orderNo, price, item, preIndexTypeLabel) {
            let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
            let that = this

            this.$confirm('您确定下载该缩水单吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params: { orderNo, coin: price },
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        that.$vuex('vuex_downFile_progress', percentCompleted >= 100 ? false : percentCompleted)
                    },
                }).then(downRes => {
                    if (downRes.code == 500) { return this.$message.error(res.msg) }
                    let fileName = `${item.title}.zip`
                    this.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            });
        },

        // 创建订单
        async fun_createOrder (price, item, productId, specsId) {
            let lotteryType = ['双色球', '大乐透', '福彩3D', '体彩排三']
            // 创建订单号
            let params = {
                money: price,
                productAuthor: item.shrinkId || item.createUser,	//商家id
                productId,
                productSpecsId: specsId,
                payType: 'balancepay',
                productModel: 0,
                quantity: 1,
                title: `${lotteryType[item.preType * 1]} - ${item.nickName} - ${item.number}`,
                uuid: new Date().getTime(),
            }

            console.log('params----------', params);

            let resCreateOrder = await createOrder(params)
            if (resCreateOrder.code == 500) {
                this.$message.error(resCreateOrder.msg)
                return null;
            }
            console.log('resCreateOrder', resCreateOrder);

            return resCreateOrder.data.orderNo
        },
    }
}
</script>

<style lang="scss" scoped>
.hidden-element {
    display: none;
    /* 其他样式... */
    font-size: 10px;
}

.show:hover + .hidden-element {
    display: block;
}

.el-pagination {
    max-width: max-content;
    margin-left: auto;
}

::v-deep .el-table td.el-table__cell div {
    padding: 0;
}
.lottery {
    display: flex;
    align-items: flex-start;
    background-color: rgba(0, 0, 0, 0.2);
    > div {
        width: 100px;
        text-align: center;
        height: 50px;
        line-height: 50px;
        // background-color: #f2f2f2;
        cursor: pointer;
        &.active {
            background-color: #409eff;
            color: #fff;
        }
    }
}
.preIndexType {
    display: flex;
    flex-wrap: wrap;
    > div {
        height: 50px;
        line-height: 50px;
        text-align: center;
        width: 100px;
        cursor: pointer;
        &.active {
            background-color: #409eff;
            color: #fff;
        }
    }
}

.history_sorting_table {
    .spans {
        display: flex;
        color: #000;
        span {
            display: inline-block;
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border: 1px solid #ccc;
            cursor: pointer;
            background-color: #fcd5b4;
            &:nth-child(-n + 24) {
                // background-color: #ccffff;
            }
            &:nth-last-child(-n + 9) {
                // background-color: #fcd5b4;
            }
            &.correct {
                background-color: #ff6600;
            }
            &.blankLine {
                border-left: 3px solid #000;
            }
        }
    }
}
.show {
    color: green;
    cursor: pointer;
    font-size: 15px;
    padding: 0;
    border: unset !important;
    flex-direction: unset !important;
    flex-wrap: wrap;
    transform-origin: bottom;
    transition: font-size 0.3s linear;
    column-gap: 5px;
    &:hover {
        font-size: 22px;
    }
}
.sss_zhuanlan {
    display: flex;
    > div {
        border: 1px solid;
    }
    .left {
        flex: 1;
        .header {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            .user {
                display: flex;
                .avatar {
                    width: 125px;
                    height: 125px;
                    margin-right: 10px;
                    border: 1px solid red;
                }
                > div {
                    flex: 1;
                    .name {
                        color: #bd312a;
                        font-weight: bold;
                    }
                    .content {
                        display: flex;
                        gap: 50px;
                        .el-tabs {
                            width: 400px;
                            margin-top: 70px;
                            margin-left: -425px;
                        }
                    }
                }
                .btns {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    border: 1px solid gray;
                    flex: 1;
                    text-align: center;
                    margin-left: 20px;
                    > div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border: 1px solid gray;
                        cursor: pointer;
                        &:hover {
                            background-color: #93d2f3;
                            color: #fff;
                        }
                    }
                }
            }
            .msg {
                color: #bd312a;
                margin: 10px 0;
                display: flex;

                > div {
                    flex: 1;
                    border-bottom: 1px solid #bd312a;
                }
            }
        }
        .table1 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;
                span {
                    margin-right: 10px;
                    cursor: pointer;
                    &.active {
                        background-color: #951d1d;
                        color: #fff;
                    }
                }
            }
            .grid {
                // height: 300px;
                > div {
                    display: grid;
                    grid-template-columns: 0.5fr 2fr 1fr 1fr 1fr;
                    text-align: center;
                    padding: 10px 0;
                    &:nth-child(odd) {
                        background-color: #f2f2f2;
                    }
                }
            }
        }
        .table2 {
            .tit {
                display: flex;
                justify-content: space-between;
                background-color: #93d2f3;
                color: #951d1d;
                padding: 5px 10px;
                span {
                    margin-right: 10px;
                    cursor: pointer;
                    &.active {
                        background-color: #951d1d;
                        color: #fff;
                    }
                }
            }
            .grid {
                font-weight: bold;
                // font-size: 12px;
                min-height: 300px;
                > div {
                    display: grid;
                    // grid-template-columns: repeat(10, 1fr);
                    grid-template-columns: 1fr 2fr repeat(8, 1fr);
                    text-align: center;
                    &:nth-child(even) {
                        background-color: #f2f2f2;
                    }
                    span {
                        padding: 5px 0;
                        border: 1px solid rgba(0, 0, 0, 0.2);
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;

                        &:first-child {
                            color: blue;
                        }
                    }
                    .sheetItem {
                        font-size: 26px;
                        line-height: 30px;
                    }
                }
            }
        }
    }
    .right {
        width: 250px;
        text-align: center;
        .tit {
            background-color: #93d2f3;
            color: #951d1d;
            border-bottom: 1px solid #951d1d;
            font-weight: bold;
            font-size: 25px;
            padding: 10px 0;
        }
        ul {
            padding: 0;
            margin: 0;
            list-style: none;
            li {
                border-bottom: 1px solid #951d1d;
                padding: 10px 0;
                cursor: pointer;
            }
        }
    }
}
.roleTab {
    display: flex;
    margin-left: 16px;
    .item {
        padding: 5px 10px;
        border-bottom: 1px solid #c1c1c1;
        color: #c1c1c1;
    }
    .activeitem {
        background: #66b1ff;
        color: #ffffff;
        border-radius: 0px;
    }
}
</style>
